import { useMemo } from 'react';
import { ProcessLayoutServiceType } from '@shared/types/process';
import { makeTree } from '@shared/util/makeTree';

export function useLayoutByRoleAndStage({
    layout,
}: {
    layout: ProcessLayoutServiceType;
}) {
    const layoutBlocks = useMemo(() => {
        return makeTree(layout.blocks);
    }, [layout]);

    return { layoutBlocks };
}
